
import { LockDec, ValidateDec } from "@/decorators";
import { TSX, Component, Prop, Vue } from 'vue-facing-decorator'

interface Props {
  item: any
}

@Component({})
export default class extends TSX<Props>()(Vue) implements Props {
  /** 商品列表行 */
  @Prop({})
  item: any;

  submitLoading = false;

  formData = {
    unit: '',
  }

  created() {
    this.formData.unit = this.item?.unit || '';
  }

  /** 单位选填，空串合法（传空串即清空），只在有值时管长度 */
  validateUnit(v) {
    if (!v) return;
    if (String(v).length > 10) throw '单位最多10个字符';
  }

  @ValidateDec("form")
  @LockDec("submitLoading")
  async submit() {
    /** 只发 unit：空串即清空；不带 name 就不会动商品名 */
    await this.$postNotify("/manager/goods/base-operat", {
      id: this.item.id,
      unit: this.formData.unit,
    })
    this.$emit("resolve")
  }

  close() {
    this.$emit("reject", { msg: '取消' })
  }
}
